import { createAxiosInstance } from './http';

export const sendRemoveRequest = async (data) => {
  const res = await createAxiosInstance().post('/remove', data);
  return res.data;
};

